/** @jsxImportSource @emotion/react */
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import 'features/geocoder/utils/registerProjections';
import MapArea from 'features/userData/map/MapArea';
import GeocoderResultsTable from './components/GeocoderResultsTable';
import { style as userDataPanelStyles } from 'features/userData/style';
import useGeocoderAppState from 'features/geocoder/hooks/useGeocoderAppState';
import GeocoderControlPanel from './components/layer/GeocoderControlPanel';
import WorkspaceLayout from 'components/my_map/workspace/WorkspaceLayout';
import { MY_MAP_WORKSPACE_TABS } from 'components/my_map/workspace/tabs';
import useUploadWorkflow from './hooks/useUploadWorkflow';
import DataPreviewGrid from './components/DataPreviewGrid';
import { Box, Typography } from '@mui/material';

import {
    encodingOptions,
    delimiterOptions,
    geocodingTypeOptions,
    coordSystemOptions,
} from 'constants/geocoder/options';
import { GeoCodingProvider } from 'features/geocoder/context/GeoCodingContext';
import GeocoderContent from './components/GeocoderContent';

export default function GeoCoderPage() {


    return (
        <GeoCodingProvider>
            <GeocoderContent />
        </GeoCodingProvider>
    );
}

